import React, { useState } from "react";
import  { submitExtraUsage } from './inventoryApi';

export default function ExtraUsageModal({
  campId,
  technicianId,
  item,
  onClose,
  onSuccess
}) {
  const [form, setForm] = useState({
    quantity_used: "",
    datetime: new Date().toISOString().slice(0, 16),
    remarks: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.quantity_used || Number(form.quantity_used) <= 0)
      e.quantity_used = "Must be greater than 0";
    if (!form.remarks.trim()) e.remarks = "Remarks are required";
    return e;
  };
  const getTechnicianId = () => {
  if (technicianId) return technicianId;

  try {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser?.id) {
      return storedUser.id;
    }

    if (storedUser?.technician_id) {
      return storedUser.technician_id;
    }

    return null;
  } catch (err) {
    console.error("Failed to get technician id from localStorage", err);
    return null;
  }
};

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    setSubmitting(true);
    try {
       const finalTechnicianId = getTechnicianId();
 
       if (!finalTechnicianId) {
         setErrors({
           submit: "Technician ID not found."
         });
         return;
       }
       await submitExtraUsage({
         technician_id: finalTechnicianId,
         camp_id: campId,
         inventory_item_id: item.inventory_item_id,
         quantity_used: Number(form.quantity_used),
         used_at: form.datetime,  
         remarks: form.remarks,
       });
      setSuccessMsg("✓ Extra usage logged successfully");
      setTimeout(() => onSuccess(), 1500);
    } catch {
      setErrors({ submit: "Failed to submit. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-60 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="flex justify-between items-center p-5 border-b">
          <h3 className="text-lg font-bold text-gray-900">Extra Inventory Usage</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl font-bold">×</button>
        </div>
        <div className="p-5 space-y-4">
          {successMsg && (
            <div className="bg-green-50 border border-green-200 text-green-800 rounded-lg p-3 text-sm font-medium">{successMsg}</div>
          )}

          {/* Read-only fields */}
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Item Name</label>
            <input readOnly disabled value={item.inventory_item__item_name}
              className="w-full border border-gray-200 rounded-md px-3 py-2 bg-gray-100 text-gray-700 text-sm" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Remaining Stock</label>
            <input readOnly disabled value={item.remaining_stock ?? "N/A"}
              className="w-full border border-gray-200 rounded-md px-3 py-2 bg-gray-100 text-gray-700 text-sm" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Today's Usage</label>
            <input readOnly disabled value={item.todayUsage}
              className="w-full border border-gray-200 rounded-md px-3 py-2 bg-gray-100 text-gray-700 text-sm" />
          </div>

          {/* Editable fields */}
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Extra Used Quantity *</label>
            <input type="number" min="1"
              value={form.quantity_used}
              onChange={e => setForm(f => ({ ...f, quantity_used: e.target.value }))}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#11a8a4]" />
            {errors.quantity_used && <p className="text-red-500 text-xs mt-1">{errors.quantity_used}</p>}
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Date & Time *</label>
            <input type="datetime-local"
              value={form.datetime}
              onChange={e => setForm(f => ({ ...f, datetime: e.target.value }))}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#11a8a4]" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Remarks *</label>
            <textarea rows={3}
              value={form.remarks}
              onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#11a8a4]"
              placeholder="Enter remarks..." />
            {errors.remarks && <p className="text-red-500 text-xs mt-1">{errors.remarks}</p>}
          </div>

          {errors.submit && <p className="text-red-600 text-sm">{errors.submit}</p>}

          <button onClick={handleSubmit} disabled={submitting}
            className="w-full text-white py-2 rounded-md font-medium text-sm"
            style={{ background: submitting ? "#ccc" : "#91d537" }}>
            {submitting ? "Submitting..." : "Submit Extra Usage"}
          </button>
        </div>
      </div>
    </div>
  );
}